<template>
    <div class="subject-container" v-b-toggle="collapseId">
        <div class="subject-header">
            <avatar class="avatar" :size="45" :src="result.value.picture" :username="result.value.title" />
            <h4 class="title">
                {{ result.value.title }}
            </h4>
            <h2 class="evaluations-count">
                {{ result.evaluations_count + ' ' + $t('values.evaluations') }}
            </h2>
        </div>
        <b-row v-if="showResults" no-gutters class="results">
            <b-col cols="12" xl="3" order-xl="2" class="subject-result mb-3 mb-xl-0">
                <div class="score">
                    <span> {{ $t('values.networksAverage') }} </span>
                    <span class="separator" />
                    <span>{{ result.rating_score | formatNumber }}</span>
                </div>
                <div v-if="result.classification !== null">
                    {{ result.classification }}
                </div>
            </b-col>
            <b-col
                cols="12"
                xl="3"
                order-xl="3"
                class="subject-result ml-1 mb-3 mb-xl-0"
                v-if="result.calibrated_score !== null || result.classification_calibrated_score !== null"
            >
                <div class="calibrated-score">
                    <span> {{ $t('values.calibratedScore') }} </span>
                    <span v-if="result.calibrated_score !== null" class="separator" />
                    <span v-if="result.calibrated_score !== null">{{ result.calibrated_score | formatNumber }}</span>
                </div>
                <div v-if="result.classification_calibrated_score !== null">
                    {{ result.classification_calibrated_score }}
                </div>
            </b-col>
            <b-col class="network-result">
                <b-row>
                    <b-col
                        :key="network"
                        v-for="(networkResults, network) in result.networks_results"
                        :cols="12"
                        :lg="networksResultsColumnsSize"
                        class="result mb-2 mb-lg-0"
                    >
                        <div class="score">
                            <span>
                                {{ $t('values.network.types.' + network) }}
                            </span>
                            <span v-if="networkResults.rating_score !== null" class="separator" />
                            <span>{{ networkResults.rating_score | formatNumber }}</span>
                        </div>
                        <div v-if="networkResults.classification !== null">
                            {{ networkResults.classification }}
                        </div>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import Avatar from 'vue-avatar'

export default {
    components: {
        Avatar,
    },
    props: {
        collapseId: String,
        result: {
            type: Object,
            required: true,
        },
    },
    computed: {
        showResults() {
            return this.networksResultsCount > 0
        },
        networksResultsCount() {
            return Object.keys(this.result.networks_results).length
        },
        networksResultsColumnsSize() {
            return 12 / this.networksResultsCount
        },
    },
}
</script>
<style lang="sass" scoped>
$blue: #009ada

.calibrated-score
    display: flex
    align-items: center
    justify-content: center
    font-weight: 700

.subject-container
    margin-top: 10px
    outline: none
    cursor: pointer

    .subject-header
        display: flex
        align-items: center
        margin-bottom: 6px

        .avatar
            margin-right: 16px
        .title
            margin-right: 30px

        .title, .evaluations-count
            font-weight: 700
            font-size: 18px

    .results
        .subject-result
            display: flex
            flex-direction: column
            align-self: center
            text-align: center
            align-items: center
            justify-content: center
            padding: 5px
            padding: 15px
            border-radius: 3px
            color: white
            background-color: #6e6e6e
            min-height: 75px
</style>
